import { render, staticRenderFns } from "./PFormInputText.vue?vue&type=template&id=5980f3fc&scoped=true&"
import script from "./PFormInputText.vue?vue&type=script&lang=ts&"
export * from "./PFormInputText.vue?vue&type=script&lang=ts&"
import style0 from "./PFormInputText.vue?vue&type=style&index=0&id=5980f3fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980f3fc",
  null
  
)

export default component.exports